module.exports = __webpack_public_path__ + "img/across shoulders.9de60531.png";